"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @param ms - 지연시킬 time(ms)
 * @example delay(1234).then(action)
 * ? 1234ms 후 action 실행
 */
function default_1(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
exports.default = default_1;
